import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Typography, Container, Grid, Paper, Link, Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const SignUpForm = () => {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      if (password !== confirmPassword) {
        throw new Error(t('errors.passwordMismatch'));
      }
      const auth = getAuth();
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await sendEmailVerification(user);
      setEmailSent(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  if (emailSent) {
    return (
      <Container
        component="main"
        maxWidth="xs"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}
      >
        <Paper elevation={3} style={{ padding: '20px', width: '100%' }}>
          <Typography component="h1" variant="h5" align="center">
            {t('verification.title')}
          </Typography>
          <Box mt={3} textAlign="center">
            <Typography>
              {t('verification.message')}
            </Typography>
            <Box mt={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                  try {
                    const auth = getAuth();
                    const user = auth.currentUser;
                    if (user) {
                      await sendEmailVerification(user);
                      setError('');
                    }
                  } catch (err) {
                    setError(err.message);
                  }
                }}
              >
                {t('verification.resend')}
              </Button>
            </Box>
            <Box mt={2}>
              <Button
                variant="outlined"
                onClick={() => navigate('/signin')}
              >
                {t('verification.alreadyVerified')} {t('verification.signInLink')}
              </Button>
            </Box>
            {error && <Typography color="error" mt={2}>{error}</Typography>}
          </Box>
        </Paper>
      </Container>
    );
  }
  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}
    >
      <Paper elevation={3} style={{ padding: '20px', width: '100%' }}>
        <Typography component="h1" variant="h5" align="center">
          {t('signUp.title')}
        </Typography>
        <form onSubmit={handleSubmit} style={{ margin: '20px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label={t('signUp.email')}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label={t('signUp.password')}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label={t('signUp.confirmPassword')}
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            style={{ marginTop: '16px' }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : t('signUp.submit')}
          </Button>
        </form>
        {error && <Typography color="error" align="center">{error}</Typography>}
        <Grid container justifyContent="center" style={{ marginTop: '16px' }}>
          <Grid item>
            <Typography variant="body2" align="center">
              {t('signUp.hasAccount')}{' '}
              <Link href="/signin" variant="body2">
                {t('signUp.signInLink')}
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};
export default SignUpForm;
